type BuildStatusPieChartGeometryArgs = {
  horizontalInsetPx: number;
  slotHeight: number;
  slotWidth: number;
};

type StatusPieChartGeometry = {
  effectiveVisualHeight: number;
  innerRadius: number;
  outerRadius: number;
  visualSize: number;
};

const statusPieMinimumChartHeight = 96;
const statusPieMinimumVisualSize = 1;
const statusPieMinimumOuterRadius = 48;
const statusPieMinimumInnerRadius = 34;
const statusPieOuterRadiusRatio = 0.43;
const statusPieInnerRadiusRatio = 0.66;

export const buildStatusPieChartGeometry = ({
  horizontalInsetPx,
  slotHeight,
  slotWidth,
}: BuildStatusPieChartGeometryArgs): StatusPieChartGeometry => {
  const effectiveVisualHeight = Math.max(statusPieMinimumChartHeight, Math.floor(slotHeight));
  const visualSize = Math.max(
    statusPieMinimumVisualSize,
    Math.floor(
      Math.min(slotHeight, Math.max(statusPieMinimumVisualSize, slotWidth - horizontalInsetPx * 2)),
    ),
  );
  const maximumOuterRadius = Math.max(statusPieMinimumVisualSize, Math.floor(visualSize / 2) - 1);
  const outerRadius = Math.min(
    maximumOuterRadius,
    Math.max(statusPieMinimumOuterRadius, Math.floor(visualSize * statusPieOuterRadiusRatio)),
  );
  const innerRadius = Math.min(
    Math.max(statusPieMinimumVisualSize, outerRadius - 1),
    Math.max(statusPieMinimumInnerRadius, Math.floor(outerRadius * statusPieInnerRadiusRatio)),
  );

  return {
    effectiveVisualHeight,
    innerRadius,
    outerRadius,
    visualSize,
  };
};
